module.exports = {
  pictureConfig: {
    picSize: '4', // 图片最大5M
    picFormat: ['.jpg', '.jpeg', '.png', '.JPG'],
  }
}